// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle/squadbusters/" + chunkId + "." + {"110":"c07405f6734338f1a3e6","236":"7b242cc564b651d7c49f","306":"ea67d9c184174d840269","312":"7306f1b31e3f55d14cb0","336":"85d49b8ff5d69969e18b","358":"026b6f75e48a4ebc9bb3","449":"5d3eb458bb780079f982","870":"a8c0560034c1ef4a8c7d","879":"e4777ce58d73ae974b52"}[chunkId] + ".min.js";
};